module.exports = __webpack_public_path__ + "img/AST.b1f778ef.svg";